import { get, post } from '../utils/makeRequest';

const AGGREGATE_ENDPOINTS = {
  GET_DATA: '/aggregate/data', // Fixed: Changed from '/forex/aggregate/data' to '/aggregate/data'
  GET_SYMBOLS: '/aggregate/symbols', // Fixed: Changed from '/forex/aggregate/symbols' to '/aggregate/symbols'
  MANUAL_REFETCH: '/aggregate/manual-refetch', // Add this endpoint
};

export const aggregateService = {
  /**
   * Get aggregate data for a symbol and timeframe with API key
   * @param {string} symbol - Currency pair symbol
   * @param {string} timeframe - Timeframe (minute, hour, day, week, month, quarter, year)
   * @param {string} apiKey - User's API key
   * @returns {Promise} - Aggregate data
   */
  getAggregateData: async (symbol, timeframe, apiKey) => {
    if (!symbol || !timeframe || !apiKey) {
      throw new Error('Symbol, timeframe, and API key are required');
    }
    
    const endpoint = `${AGGREGATE_ENDPOINTS.GET_DATA}?symbol=${encodeURIComponent(symbol)}&timeframe=${encodeURIComponent(timeframe)}&apiKey=${encodeURIComponent(apiKey)}`;
    return get(endpoint);
  },

  /**
   * Get available symbols and timeframes with API key
   * @param {string} apiKey - User's API key
   * @returns {Promise} - Available symbols and timeframes
   */
  getAvailableSymbols: async (apiKey) => {
    if (!apiKey) {
      throw new Error('API key is required');
    }
    
    const endpoint = `${AGGREGATE_ENDPOINTS.GET_SYMBOLS}?apiKey=${encodeURIComponent(apiKey)}`;
    return get(endpoint);
  },

  /**
   * Trigger manual refetch of all aggregate data
   * @param {string} apiKey - User's API key
   * @returns {Promise} - Refetch response
   */
  triggerManualRefetch: async (apiKey) => {
    if (!apiKey) {
      throw new Error('API key is required');
    }
    
    const endpoint = `${AGGREGATE_ENDPOINTS.MANUAL_REFETCH}?apiKey=${encodeURIComponent(apiKey)}`;
    return post(endpoint, {}); // POST request with empty body, API key in query params
  },
};
